import React from 'react'
import type {MembershipSubscription} from './api'

export interface LinkedMembershipChooserProps {
  /** Usable memberships of a user who has no active subscription yet. */
  memberships: MembershipSubscription[]
  /** Called with the full key of the membership the user wants to use. */
  onChoose: (skey: string) => void
  disabled?: boolean
}

/**
 * Lets a user who belongs to several subscriptions, but has none active, pick the one to use.
 * Shown in Settings instead of a dead end ("Subscription details unavailable"); a single usable
 * membership is activated by `SubscriptionProvider` without asking.
 */
export const LinkedMembershipChooser: React.FC<LinkedMembershipChooserProps> = ({
  memberships,
  onChoose,
  disabled = false,
}) => {
  if (memberships.length === 0) {
    return null
  }
  return (
    <div className='mb-3'>
      <p className='mb-2'>Your account is a member of these subscriptions. Choose the one to use:</p>
      <div className='d-flex flex-column align-items-center gap-2'>
        {memberships.map((sub) => (
          <button
            key={sub.skey}
            type='button'
            className='btn btn-sm btn-primary'
            onClick={() => onChoose(sub.skey)}
            disabled={disabled}
          >
            {sub.product || 'Subscription'} — {sub.subscription_id} ({sub.role})
          </button>
        ))}
      </div>
    </div>
  )
}
